import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledInsightTitle = styled.header`
  color: #a3a3a3;
  margin-bottom: 0.5rem;
`;
export const StyledInsightContent = styled.main`
  color: ${getColor('shuttleGray')};
`;

export const StyledInsightValue = styled.span`
  font-size: 2rem;
  margin-right: 0.5rem;
`;

export const StyledIsChecked = styled.div``;

export const StyledInsightItem = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 1.2rem;
  border-bottom: 1px solid ${getColor('silverSand')};
  padding: 1rem;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  &.isChecked {
    background-color: ${getColor('catskillWhite')};
  }

  &.isSelected {
    background-color: ${getColor('zircon')};
  }

  & > aside {
    margin-left: auto;
  }
`;
